import { Link } from "react-router-dom";

const STATS = [
  { number: "15+", label: "Years in Northern Virginia" },
  { number: "2,400+", label: "Residential Jobs Done" },
  { number: "200+", label: "5-Star Google Reviews" },
  { number: "100%", label: "Satisfaction Guarantee" },
];

const BENEFITS = [
  {
    icon: "ri-shield-check-fill",
    title: "Fully Licensed & Insured",
    desc: "Comprehensive liability insurance and workers' comp on every job. Proof of insurance available on request.",
  },
  {
    icon: "ri-award-fill",
    title: "ISA Certified Arborists",
    desc: "Our certified arborists assess your trees properly — ensuring the right decision between removal vs. trimming.",
  },
  {
    icon: "ri-tools-fill",
    title: "Professional-Grade Equipment",
    desc: "Bucket trucks, cranes, and precision grinders let us handle any job safely — from small yards to large estates.",
  },
  {
    icon: "ri-money-dollar-circle-fill",
    title: "Upfront, Transparent Pricing",
    desc: "You get a written estimate with every item listed. No hidden fees, no surprises when the invoice arrives.",
  },
  {
    icon: "ri-timer-flash-fill",
    title: "Fast Response & Scheduling",
    desc: "We respond within hours, not days. Emergency service available 24/7 for storm damage and fallen trees.",
  },
  {
    icon: "ri-broom-fill",
    title: "Complete Cleanup Included",
    desc: "All debris, logs, and wood chips are hauled away (or spread as mulch). Your yard left cleaner than we found it.",
  },
];

export default function WhyChooseUs() {
  return (
    <section className="py-24 bg-[#f8f6f3] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        {/* Top: Split intro */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
          {/* Left: image stack */}
          <div className="relative">
            {/* Main image */}
            <div className="rounded-3xl overflow-hidden h-[480px]">
              <img
                src="https://public.readdy.ai/ai/img_res/4b3f992b72106b1cb8c5030ed6d68f74.jpg"
                alt="Diversified Tree Services owner and fleet"
                className="w-full h-full object-cover object-top"
              />
            </div>

            {/* Floating: reviews card */}
            <div className="absolute -bottom-6 -right-4 lg:-right-10 bg-white rounded-2xl px-6 py-5 w-56" style={{ boxShadow: "0 8px 32px rgba(0,0,0,0.12)" }}>
              <div className="flex gap-0.5 mb-2">
                {[1,2,3,4,5].map((s) => <i key={s} className="ri-star-fill text-yellow-400 text-sm"></i>)}
              </div>
              <div className="text-[#e8632a] font-black text-3xl">200+</div>
              <div className="text-[#1e1e1e] font-bold text-xs uppercase tracking-wide">5-Star Google Reviews</div>
            </div>

            {/* Floating: since badge */}
            <div className="absolute -top-4 -left-4 lg:-left-8 bg-[#e8632a] text-white rounded-2xl px-5 py-4 text-center">
              <div className="font-black text-2xl">2008</div>
              <div className="font-bold text-xs uppercase tracking-wide text-white/80">Est.</div>
            </div>
          </div>

          {/* Right: content */}
          <div>
            <span className="text-[#e8632a] font-bold text-sm uppercase tracking-[3px] block mb-4">Why Choose Us</span>
            <h2 className="text-4xl lg:text-5xl font-black text-[#1e1e1e] leading-tight mb-5">
              Northern Virginia's<br />
              <span className="text-[#1a3a2e]">Most Trusted</span><br />
              Tree Service Team
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-8">
              When you hire Diversified Tree Services, you get a crew that shows up on time, communicates clearly, works safely, and leaves your property spotless. No games, no shortcuts.
            </p>

            {/* Stats row */}
            <div className="grid grid-cols-2 gap-4 mb-8">
              {STATS.map((s) => (
                <div key={s.label} className="bg-white rounded-2xl px-5 py-4">
                  <div className="text-[#e8632a] font-black text-2xl">{s.number}</div>
                  <div className="text-gray-500 text-xs font-medium mt-0.5">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="flex items-center gap-4">
              <Link
                to="/about"
                className="flex items-center gap-2 px-6 py-3 bg-[#1a3a2e] text-white font-black rounded-xl uppercase tracking-wide hover:bg-[#0f2018] transition-all cursor-pointer whitespace-nowrap"
              >
                Meet Our Team <i className="ri-arrow-right-line"></i>
              </Link>
              <a
                href="tel:+15407764488"
                className="flex items-center gap-2 text-[#e8632a] font-black cursor-pointer hover:underline"
              >
                <i className="ri-phone-fill"></i>(540) 776-4488
              </a>
            </div>
          </div>
        </div>

        {/* Bottom: benefits grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {BENEFITS.map((b, i) => (
            <div
              key={b.title}
              className="bg-white rounded-2xl p-6 flex gap-4 hover:translate-y-[-2px] transition-transform"
              style={{ marginTop: i % 3 === 1 ? "16px" : "0px" }}
            >
              <div className="w-11 h-11 flex items-center justify-center bg-[#e8632a]/10 rounded-xl flex-shrink-0">
                <i className={`${b.icon} text-[#e8632a] text-xl`}></i>
              </div>
              <div>
                <h3 className="font-black text-[#1e1e1e] text-sm mb-1.5">{b.title}</h3>
                <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
